var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{staticClass:"pageheader"},[_c('h1',[_vm._v("Gyakori kérdések")]),_c('nav',{staticClass:"breadcrumb"},[_c('ul',[_c('li',[_c('a',{attrs:{"href":_setup.categoryUrl}},[_vm._v("Kategóriák")])]),_c('li',[_vm._v("Keresés")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }